import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-components';
/**
 * Render the final JSX of SensitivityIcon
 */
export const renderSensitivityIcon_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/_jsxs(state.root, {
    children: [state.backgroundIcon && /*#__PURE__*/_jsx(state.backgroundIcon, {}), state.foregroundIcon && /*#__PURE__*/_jsx(state.foregroundIcon, {}), state.root.children]
  });
};
//# sourceMappingURL=renderSensitivityIcon.js.map